import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import CloseIcon from "../../assets/images/close.png";


import { TfiTrash } from "react-icons/tfi";
import { Disable } from 'react-disable';



import { connect } from "react-redux";
import { compose } from "redux";


import { addAttachmentAction, editAction, getActionDetails, addActionComment, deleteAttachmentAction, getUsersList } from "../../store/actions/riskActions";
import Select, { components } from "react-select";

import moment from 'moment';
import debounce from "lodash/debounce";
import { CommentsSection } from "../Comments";
import { SidePanel, ModalHeader, ModalBody, RaboInput, RaboTextarea, RaboButton } from "../ui";
import { translatePriorityDisplay } from "../../utils/i18nDisplayLabels";

const actionSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: 40,
        height: 40,
        borderColor: state.isFocused ? '#9ca3af' : '#e5e7eb',
        backgroundColor: '#f9fafb',
        boxShadow: 'none',
        borderRadius: '0.5rem',
        fontSize: '13px',
        cursor: 'pointer',
        '&:hover': { borderColor: '#9ca3af' },
    }),
    valueContainer: (provided) => ({ ...provided, padding: '0 8px', height: 38 }),
    input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
    indicatorsContainer: (provided) => ({ ...provided, height: 38, paddingRight: 4 }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (provided) => ({ ...provided, padding: '0 4px', color: '#6b7280' }),
    menu: (provided) => ({ ...provided, border: 'none', zIndex: 999999999999 }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#111827' : state.isFocused ? '#f3f4f6' : 'white',
        color: state.isSelected ? 'white' : '#111827',
        fontSize: '13px',
        padding: '8px 12px',
    }),
    placeholder: (provided) => ({ ...provided, color: '#9ca3af', fontSize: '13px' }),
    singleValue: (provided) => ({ ...provided, color: '#374151', fontSize: '13px', margin: 0 }),
};

function ActionField({ label, children, className }) {
    return (
        <div className={className}>
            <label className="block text-[12px] font-medium text-gray-500 mb-1.5 uppercase tracking-wide">
                {label}
            </label>
            {children}
        </div>
    );
}

const customStyles = actionSelectStyles;

function AddPeopleIcon({ size = 20 }) {
    return (
        <svg
            fill="currentColor"
            aria-hidden="true"
            width={size}
            height={size}
            viewBox="0 0 20 20"
        >
            <path d="M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0 0 9 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 0 1 9.6 17 12 12 0 0 1 9 17a8.16 8.16 0 0 1-4.33-1.05A3.36 3.36 0 0 1 3 13a1 1 0 0 1 1-1h5.6c.18-.36.4-.7.66-1H4Zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z" />
        </svg>
    );
}

function Avatar({ name, src, size = 28 }) {
    const [errored, setErrored] = React.useState(false);

    const initials = (name || "")
        .split(" ")
        .map((s) => s[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();

    if (!src || errored) {
        return (
            <div
                className="flex items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-gray-500"
                style={{ width: size, height: size }}
                title={name}
            >
                <svg
                    width={Math.floor(size * 0.6)}
                    height={Math.floor(size * 0.6)}
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                >
                    <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1c-3.33 0-6 1.34-6 3v2h12v-2c0-1.66-2.67-3-6-3Z" />
                </svg>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={name}
            title={name}
            loading="lazy"
            referrerPolicy="no-referrer"
            className="rounded-full object-cover border border-gray-300 bg-white"
            style={{ width: size, height: size }}
            onError={() => setErrored(true)}
        />
    );
}

export function PeoplePicker({
    users = [],           // [{value, label, avatar}]
    value = [],           // selected [{value, label, avatar}]
    onChange = () => { },
    placeholder,
}) {
    const { t } = useTranslation();
    const ownersLabel = placeholder ?? t("actionOverlay.owners");
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const rootRef = useRef(null);

    // close on outside click
    useEffect(() => {
        function onDocClick(e) {
            if (!rootRef.current) return;
            if (!rootRef.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    const selectedIds = useMemo(() => new Set(value.map((v) => v.value)), [value]);
    
    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return users;
        return users.filter(
            (u) =>
                String(u.label).toLowerCase().includes(q) ||
                String(u.value).toLowerCase().includes(q)
        );
    }, [users, query]);

     //console.log("users ", users)
    const selected = value;
    const allUnselected = filtered.filter((u) => !selectedIds.has(u.value));
    const unselected = query.trim() ? allUnselected : allUnselected.slice(0, 5);

    const toggle = (user) => {
        if (selectedIds.has(user.value)) {
            onChange(value.filter((v) => v.value !== user.value));
        } else {
            onChange([...value, user]);
        }
    };

    return (
        <div ref={rootRef} className="relative">
            {/* COMPACT VIEW — avatars only, each with a tiny × to remove; click area opens dropdown */}
            <div className="flex items-center gap-2">
                {/* always-visible Teams add icon */}
                <button
                    type="button"
                    className="w-9 h-9 rounded-full border flex items-center justify-center hover:bg-gray-100 text-gray-700 shrink-0"
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen((s) => !s);
                    }}
                    aria-expanded={open}
                    aria-label={ownersLabel}
                    title={ownersLabel}
                >
                    {/* the exact SVG you provided */}
                    <svg fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">
                        <path d="M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0 0 9 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 0 1 9.6 17 12 12 0 0 1 9 17a8.16 8.16 0 0 1-4.33-1.05A3.36 3.36 0 0 1 3 13a1 1 0 0 1 1-1h5.6c.18-.36.4-.7.66-1H4Zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z" />
                    </svg>
                </button>

                {/* avatars (overlap), click anywhere else toggles dropdown if you want */}
                <div
                    className="flex items-center"
                    onClick={() => setOpen((s) => !s)}
                    role="button"
                    aria-label={t("actionOverlay.ownersToggle")}
                    title={ownersLabel}
                >
                    {selected?.length === 0 ? (
                        <div className="ml-0">
                            <Avatar name={t("actionOverlay.noOwner")} src="" size={28} />
                        </div>
                    ) : (
                        selected.map((u, idx) => (
                            <div key={u.value ?? idx} className={idx === 0 ? "relative" : "relative ml-1"}>
                                <Avatar name={u.label} src={u.avatar} size={28} />
                                {/* tiny × to remove (doesn't close/open dropdown) */}
                                <button
                                    type="button"
                                    className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-white border text-[10px] leading-none flex items-center justify-center hover:bg-gray-100"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        // call your toggle/remove
                                        onChange(selected.filter(v => v.value !== u.value));
                                    }}
                                    aria-label={t("actionOverlay.removeOwner", { name: u.label })}
                                    title={t("actionOverlay.removeOwner", { name: u.label })}
                                >
                                    ×
                                </button>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* DROPDOWN — narrower; click row to add/remove; shows Selected then All members */}
            {open && (
                <div className="absolute z-50 mt-2 w-64 rounded-xl border bg-white shadow-xl p-3">
                    <input
                        type="text"
                        placeholder={t("actionOverlay.searchPeople")}
                        className="w-full border rounded-md px-3 py-2 mb-3 outline-none focus:ring-2 focus:ring-blue-500"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />

                    {selected?.length > 0 && (
                        <>
                            <div className="text-xs font-semibold text-gray-500 px-1 mb-1">{t("actionOverlay.selected")}</div>
                            <ul className="max-h-48 overflow-auto mb-2">
                                {selected.map((u) => {
                                    const isSelected = true;
                                    return (
                                        <li
                                            key={`sel-${u.value}`}
                                            className={`flex items-center justify-between rounded-lg px-2 py-2 cursor-pointer ${isSelected ? "bg-blue-50 hover:bg-blue-100" : "hover:bg-gray-50"
                                                }`}
                                            onClick={() => toggle(u)} // click row to remove
                                        >
                                            <div className="flex items-center gap-2">
                                                <Avatar name={u.label} src={u.avatar} size={24} />
                                                <span className="text-sm">{u.label}</span>
                                            </div>
                                            <span className="text-xs text-blue-600">×</span>
                                        </li>
                                    );
                                })}
                            </ul>
                            <div className="h-px bg-gray-200 my-2" />
                        </>
                    )}

                    <div className="text-xs font-semibold text-gray-500 px-1 mb-1">{t("actionOverlay.allMembers")}</div>
                    <ul className="max-h-64 overflow-auto">
                        {unselected?.length === 0 && (
                            <li className="text-sm text-gray-500 px-2 py-2">{t("actionOverlay.noMatches")}</li>
                        )}
                        {unselected.map((u) => {
                            const isSelected = selectedIds.has(u.value);
                            return (
                                <li
                                    key={u.value}
                                    className={`flex items-center justify-between rounded-lg px-2 py-2 cursor-pointer ${isSelected ? "bg-blue-50 hover:bg-blue-100" : "hover:bg-gray-50"
                                        }`}
                                    onClick={() => toggle(u)} // click row to add
                                >
                                    <div className="flex items-center gap-2">
                                        <Avatar name={u.label} src={u.avatar} size={24} />
                                        <span className="text-sm">{u.label}</span>
                                    </div>
                                    {/* subtle check on selected (in case filtering brings selected into this list) */}
                                    {isSelected ? <span className="text-xs text-blue-600">✓</span> : null}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}


const ActionOverlay = (props) => {

    const { action_attachments, deleteAttachmentFN , owners, risk_id, editActionFN, profile, closeAction, getActionDetailsFN, action_id, action_details, action_comments, addActionCommentFN, getUsersFN, users, addAttachmentActionFN, open, onClose } = props;
    const { t } = useTranslation();
    const useModalShell = typeof open === "boolean";


    const fileInputRef = React.useRef(null);

    const handleFileChange = (event, actionId) => {
        const files = Array.from(event.target.files || []);

        if (!files.length) return;

        files.forEach((file) => {
            addAttachmentActionFN(actionId, file)
                .then((newAttachment) => {
                    setFormState((prevState) => ({
                        ...prevState,
                        Attachments: [
                            ...(prevState.Attachments || []),
                            newAttachment,
                        ],
                    }));
                })
                .catch((error) => {
                    console.error("Error adding action attachment:", error);
                });
        });

        event.target.value = "";
    };

    const normalizeActionPayload = (data) => {
        const updatedData = { ...data };
        if (updatedData.StartDate) {
            const d = new Date(updatedData.StartDate);
            d.setDate(d.getDate());
            updatedData.StartDate = d.toISOString().split("T")[0];
        }
        if (updatedData.EndDate) {
            const d = new Date(updatedData.EndDate);
            d.setDate(d.getDate());
            updatedData.EndDate = d.toISOString().split("T")[0];
        }
        return updatedData;
    };

    const persistActionRef = React.useRef(Promise.resolve());
    const hydratedActionIdRef = React.useRef(null);

    const persistAction = (data) => {
        const task = async () => {
            await editActionFN(risk_id, action_id, normalizeActionPayload(data));
        };
        persistActionRef.current = persistActionRef.current.then(task, task);
        return persistActionRef.current;
    };

    const AddComment = async (commentState, action_id) => {
        await persistAction(formState);
        addActionCommentFN(commentState, action_id);
    };


    


    const [isLoading, setIsLoading] = useState(true);

    const findOpt = (opts, v) => opts.find(o => o.value === v) || null;
    //////////console.log(users);

    const ownerAvatarMap = new Map(
        (Array.isArray(owners) ? owners : [])
            .filter(Boolean)
            .map(o => [String(o.user_id), o.avatar || ""])
    );

    const listUsers = Array.isArray(users)
        ? users.map(u => {
            const fullName = [u.first_name, u.last_name].filter(Boolean).join(" ");
            return {
                value: u.user_id,
                label: fullName || u.email || t("actionOverlay.userFallback", { id: u.user_id }),
                avatar: ownerAvatarMap.get(String(u.user_id)) || "", // fallback => initials bubble
                email: u.email,
            };
        })
        : [];

    //////////console.log(listUsers);

    //const riskResponses = ['Accept', 'Mitigate', 'Transfer', 'Avoid'];




    const [formState, setFormState] = useState({
        Title: '',
        Definition: '',
        StartDate: '',
        EndDate: '',
        User: [],
        Progress: '',
        Status: '',
        Problem: '',
        Attachments: '',
        Priority: '',


    });
    const formStateRef = React.useRef(formState);
    formStateRef.current = formState;



    const listStatus = useMemo(() => ([
        { value: 'Not started', label: t('actionOverlay.statusNotStarted'), color: "#0081A7" },
        { value: 'In progress', label: t('actionOverlay.statusInProgress'), color: "#00AFB9" },
        { value: 'Completed', label: t('actionOverlay.statusCompleted'), color: "#FED9B7" },
        { value: 'Problem', label: t('actionOverlay.statusProblem'), color: "#F07167" },
    ]), [t]);

    useEffect(() => {
        hydratedActionIdRef.current = null;
        if (action_id) {
            getUsersFN();
            getActionDetailsFN(risk_id, action_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action_id]);


    const calculateDateDifference = (startDate, endDate) => {
        const start = moment(startDate);
        const end = moment(endDate);
        const days = end.diff(start, 'days');
        if (days === 0) return t('actionOverlay.daysLeftZero');
        return t('actionOverlay.daysLeftValue', { count: days });
    };


    const formatFileName = (name) => {
        if (!name) return t("actionOverlay.unnamedAttachment");

        const extIndex = name.lastIndexOf(".");
        if (extIndex === -1) {
            return name.length > 12 ? `${name.slice(0, 12)}...` : name;
        }

        const base = name.slice(0, extIndex);
        const ext = name.slice(extIndex);

        return base.length > 10
            ? `${base.slice(0, 10)}...${ext}`
            : name;
    };

    const mapOwnersFromDetails = React.useCallback((details, usersList) => {
        let rawOwners = details?.owners;
        if (typeof rawOwners === "string") {
            try { rawOwners = JSON.parse(rawOwners); } catch { rawOwners = []; }
        }
        if (Array.isArray(rawOwners) && rawOwners.length > 0) {
            return rawOwners
                .filter(Boolean)
                .map((o) => {
                    const uid = o.user_id ?? o.value;
                    const fromList = usersList.find((u) => Number(u.value) === Number(uid));
                    return fromList || {
                        value: uid,
                        label: [o.first_name, o.last_name].filter(Boolean).join(" ").trim() || String(uid),
                        avatar: o.avatar || "",
                    };
                });
        }

        let ownerIds = [];
        if (Array.isArray(details?.user_id)) {
            ownerIds = details.user_id;
        } else if (typeof details?.user_id === "string") {
            try {
                const parsed = JSON.parse(details.user_id);
                ownerIds = Array.isArray(parsed) ? parsed : [parsed];
            } catch {
                ownerIds = [];
            }
        } else if (details?.user_id != null) {
            ownerIds = [details.user_id];
        }

        const idSet = new Set(ownerIds.map(Number).filter(Number.isFinite));
        return usersList.filter((u) => idSet.has(Number(u.value)));
    }, []);

    useEffect(() => {
        if (!action_details || !action_id) return;
        if (hydratedActionIdRef.current === action_id) return;

        const newStatus = listStatus.find(
            (status) => status.value === action_details.progress
        );
        const newUser = mapOwnersFromDetails(action_details, listUsers);

        setFormState({
            Title: action_details.title,
            Definition: action_details.details,
            StartDate: moment(action_details.start_date).format("YYYY-MM-DD"),
            EndDate: moment(action_details.end_date).format("YYYY-MM-DD"),
            User: newUser,
            Progress: action_details.real_progress,
            Status: newStatus,
            Problem: action_details.problem,
            Attachments: action_attachments,
            Priority: action_details.priority,
        });
        hydratedActionIdRef.current = action_id;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action_details, action_id, listUsers]);

    const handleDeleteAttachment = (attachmentId) => {
        props.deleteAttachmentActionFN(action_id, attachmentId)
            .then(() => {
                setFormState((prevState) => ({
                    ...prevState,
                    Attachments: (prevState.Attachments || []).filter(
                        (attachment) => attachment.attachment_id !== attachmentId
                    ),
                }));
            })
            .catch((error) => {
                console.error("Error deleting action attachment:", error);
            });
    };


    useEffect(() => {
        if (action_details) {
            setIsLoading(false);
        }
    }, [action_details]);


    // eslint-disable-next-line react-hooks/exhaustive-deps

    const handleRiskChange = (data) => {

        setFormState(data);
        //updateServerData(data, "action", null, action_id);

    };



    const isAuditor = profile?.role === "Auditor";
    const assigneeIds = React.useMemo(() => {
        const ids = new Set();
        (owners || []).forEach((o) => {
            if (o?.user_id != null) ids.add(Number(o.user_id));
        });
        (formState.User || []).forEach((u) => {
            const id = u?.value ?? u?.user_id;
            if (id != null) ids.add(Number(id));
        });
        return ids;
    }, [owners, formState.User]);
    const isAssignee = profile?.user_id && assigneeIds.has(Number(profile.user_id));
    const canEdit = isAuditor || isAssignee;

    const disableEvent = React.useCallback(
        (e) => {
            if (!canEdit) {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        [canEdit]
    );


    const initials = (label = "") =>
        label.split(" ").map(s => s[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();

    const MultiValueLabel = (props) => {
        const label = props.data.label;
        return (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div style={{
                    width: 18, height: 18, borderRadius: 9999,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 10, fontWeight: 700, border: "1px solid #ddd"
                }}>
                    {initials(label)}
                </div>
                <span>{label}</span>
            </div>
        );
    };

    const OptionWithCheck = (props) => {
        const { isSelected, label } = props;
        return (
            <components.Option {...props}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{
                        width: 16, height: 16, borderRadius: 4,
                        border: "1px solid #bbb",
                        background: isSelected ? "#3b82f6" : "transparent"
                    }} />
                    <div style={{
                        width: 22, height: 22, borderRadius: 9999,
                        display: "inline-flex", alignItems: "center", justifyContent: "center",
                        fontSize: 10, fontWeight: 700, border: "1px solid #ddd", marginRight: 4
                    }}>
                        {initials(label)}
                    </div>
                    <span>{label}</span>
                </div>
            </components.Option>
        );
    };

    const multiStyles = {
        control: (base) => ({ ...base, minHeight: 42 }),
        multiValue: (base) => ({ ...base, borderRadius: 9999 }),
        multiValueLabel: (base) => ({ ...base, paddingRight: 6 }),
        multiValueRemove: (base) => ({ ...base, borderTopRightRadius: 9999, borderBottomRightRadius: 9999 }),
        option: (base, state) => ({
            ...base,
            paddingTop: 8, paddingBottom: 8,
            backgroundColor: state.isSelected ? "rgba(59,130,246,0.1)" : state.isFocused ? "rgba(0,0,0,0.04)" : "white",
            color: "inherit"
        }),
    };

    const getPriorityColor = (priority) => {
        switch ((priority || "").trim()) {
            case "Critical":
            case "High":
                return "text-red-700";
            case "Medium":
                return "text-orange-600";
            case "Low":
                return "text-yellow-600";
            default:
                return "text-gray-700";
        }
    };

    const DEFAULT_PRIORITY = "Low";
    const [displayPriority, setDisplayPriority] = useState(formState.Priority);

    useEffect(() => {
        if (!formState?.Priority) return;

        // If we're moving to the default (teardown/reset), wait a bit.
        if (formState.Priority === DEFAULT_PRIORITY && displayPriority !== DEFAULT_PRIORITY) {
            const t = setTimeout(() => setDisplayPriority(DEFAULT_PRIORITY), 200); // tweak 120–250ms
            return () => clearTimeout(t);
        }

        // For real user changes (e.g., Low -> High), update immediately.
        setDisplayPriority(formState.Priority);
    }, [formState?.Priority]);

    const handleModalClose = () => {
        onClose?.();
        const snapshot = formStateRef.current;
        persistActionRef.current
            .catch(() => {})
            .then(() => {
                if (closeAction) {
                    return closeAction(snapshot, action_id);
                }
                return persistAction(snapshot);
            })
            .catch((error) => {
                console.error("Action overlay background save failed:", error);
            });
    };

    if (useModalShell && !open) {
        return null;
    }

    const inner = (
        <Disable disabled={isLoading} onClick={disableEvent} onKeyDown={disableEvent}>
            <div style={canEdit ? { pointerEvents: 'auto', userSelect: 'auto' } : { pointerEvents: 'none', userSelect: 'none' }}>
                <div className={useModalShell ? "space-y-4" : "p-10 bg-white rounded-lg"}>
                    {!useModalShell && (
                    <div className="flex justify-between items-center mb-3 relative">
                        <h1 className={`text-md font-semibold ${getPriorityColor(displayPriority)}`}>
                            {translatePriorityDisplay(displayPriority, t) || displayPriority}
                        </h1>

                        <img
                            src={CloseIcon}
                            alt={t("actionOverlay.closeAlt")}
                            className="w-6 h-6 cursor-pointer absolute top-2 right-2"
                            onClick={() => handleModalClose()}
                        />
                    </div>
                    )}
                    <ActionField label={t("actionOverlay.title")}>
                        <RaboInput
                            type="text"
                            placeholder={t("actionOverlay.titlePlaceholder")}
                            value={formState.Title}
                            onChange={(e) =>
                                handleRiskChange({ ...formState, Title: e.target.value })
                            }
                        />
                    </ActionField>

                    <ActionField label={t("actionOverlay.definition")}>
                        <RaboTextarea
                            rows={3}
                            placeholder={t("actionOverlay.definitionPlaceholder")}
                            value={formState.Definition}
                            onChange={(e) =>
                                handleRiskChange({ ...formState, Definition: e.target.value })
                            }
                        />
                    </ActionField>



                    <div className="flex justify-start items-center w-full mt-4 mb-4">
                        <PeoplePicker
                            users={listUsers}
                            value={Array.isArray(formState.User) ? formState.User : []}
                            onChange={(arr) => {
                                const next = { ...formState, User: arr };
                                setFormState(next);
                                if (canEdit && action_id && hydratedActionIdRef.current === action_id) {
                                    persistAction(next).catch((err) =>
                                        console.error("Failed to persist action owners:", err)
                                    );
                                }
                            }}
                        />
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <ActionField label={t("actionOverlay.startDate")}>
                            <RaboInput
                                type="date"
                                value={formState.StartDate || ""}
                                onChange={(e) =>
                                    handleRiskChange({ ...formState, StartDate: e.target.value })
                                }
                            />
                        </ActionField>

                        <ActionField label={t("actionOverlay.endDate")}>
                            <RaboInput
                                type="date"
                                value={formState.EndDate || ""}
                                onChange={(e) =>
                                    handleRiskChange({ ...formState, EndDate: e.target.value })
                                }
                            />
                        </ActionField>

                        <ActionField label={t("actionOverlay.daysLeft")}>
                            <RaboInput
                                readOnly
                                value={
                                    formState.StartDate && formState.EndDate
                                        ? calculateDateDifference(formState.StartDate, formState.EndDate)
                                        : ""
                                }
                            />
                        </ActionField>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <ActionField label={t("actionOverlay.progress")}>
                            <div className="relative w-full h-10 bg-gray-100 rounded-lg flex items-center px-3">
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value={formState.Progress || 0}
                                    onChange={(e) =>
                                        handleRiskChange({ ...formState, Progress: e.target.value })
                                    }
                                    className="absolute inset-x-3 h-2 appearance-none bg-transparent rounded-full cursor-pointer"
                                    style={{
                                        background: `linear-gradient(to right, #09A6B0 ${formState.Progress || 0}%, #f07167 ${formState.Progress || 0}%)`,
                                    }}
                                />
                                <span className="relative ml-auto text-[13px] font-medium text-gray-700 shrink-0">
                                    {formState.Progress || 0}%
                                </span>
                            </div>
                        </ActionField>

                        <ActionField label={t("actionOverlay.status")}>
                            <Select
                                options={listStatus}
                                placeholder={t("actionOverlay.statusPlaceholder")}
                                value={formState.Status}
                                onChange={(opt) => handleRiskChange({
                                    ...formState,
                                    Status: opt
                                })}
                                styles={actionSelectStyles}
                                classNamePrefix="action-select"
                            />
                        </ActionField>
                    </div>


                    {formState.Status?.value === 'Problem' && (
                        <ActionField label={t("actionOverlay.problem")}>
                            <RaboTextarea
                                rows={3}
                                placeholder={t("actionOverlay.problemPlaceholder")}
                                value={formState.Problem}
                                onChange={(e) =>
                                    handleRiskChange({ ...formState, Problem: e.target.value })
                                }
                            />
                        </ActionField>
                    )}

                    <ActionField label={t("actionOverlay.attachments")}>
                        {formState.Attachments && formState.Attachments.length > 0 && (
                            <ul className="mb-3 space-y-2">
                                {formState.Attachments.map((attachment) => (
                                    <li
                                        key={attachment.attachment_id}
                                        className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-3 py-2 hover:bg-gray-50 transition"
                                    >
                                        <a
                                            href={attachment.file_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-[13px] text-blue-600 hover:underline truncate max-w-[180px]"
                                        >
                                            {formatFileName(attachment.attachment_name)}
                                        </a>

                                        <button
                                            type="button"
                                            className="text-gray-500 hover:text-red-500 ml-3 transition"
                                            onClick={() => handleDeleteAttachment(attachment.attachment_id)}
                                        >
                                            <TfiTrash size={15} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}

                        <RaboButton
                            variant="outline"
                            size="sm"
                            type="button"
                            onClick={() => fileInputRef.current?.click()}
                        >
                            {t("actionOverlay.addAttachment")}
                        </RaboButton>

                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={(event) => handleFileChange(event, action_id)}
                        />
                    </ActionField>



                    <CommentsSection
                        comments={action_comments}
                        profile={profile}
                        title={t("actionOverlay.comments")}
                        placeholder={t("actionOverlay.commentsPlaceholder")}
                        addButtonLabel={t("actionOverlay.addComment")}
                        onSubmit={(html) => AddComment(html, action_id)}
                    />


                </div >
            </div>
        </Disable >
    );

    if (useModalShell) {
        return (
            <SidePanel
                onClose={handleModalClose}
                overlayZIndex="z-[400]"
                resizable
                defaultWidth={Math.round(window.innerWidth * 0.6)}
                minWidth={420}
                className="rounded-tl-2xl"
            >
                <ModalHeader onClose={handleModalClose}>
                    <div className="flex items-center gap-2 min-w-0 pr-6">
                        {displayPriority ? (
                            <span className={`text-xs font-semibold shrink-0 ${getPriorityColor(displayPriority)}`}>
                                {translatePriorityDisplay(displayPriority, t) || displayPriority}
                            </span>
                        ) : null}
                        <p className="text-[15px] font-semibold text-gray-900 truncate">
                            {formState.Title?.trim() || t("actionOverlay.actionFallback")}
                        </p>
                    </div>
                </ModalHeader>
                <ModalBody className="space-y-4 flex-1 overflow-y-auto py-5">
                    {inner}
                </ModalBody>
            </SidePanel>
        );
    }

    return inner;
};


const mapStateToProps = (state) => {
    return {

        risk: state.risk.risk,
        profile: state.profile.profile,
        action_details: state.risk.action_details,
        action_comments: state.risk.action_comments,
        action_attachments: state.risk.action_attachments,
        users: state.risk.risk_users_list || [],
        owners: state.risk.action_details?.owners,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addAttachmentActionFN: (action_id, file) => dispatch(addAttachmentAction(action_id, file)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        getActionDetailsFN: (risk_id, action_id) => dispatch(getActionDetails(risk_id, action_id)),
        addActionCommentFN: (comment, action_id) => dispatch(addActionComment(comment, action_id)),
        getUsersFN: () => dispatch(getUsersList()),
        deleteAttachmentActionFN:(actionId, attachmentId) => dispatch(deleteAttachmentAction(actionId, attachmentId))

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(ActionOverlay);